export default {
    content: {},
    defaultStyle: {
      fontFamily: data => data.fontFamily1,
      padding: '10px',
      background: '#fff',
      marginBottom: '20px',
      '& $content': {
        margin: '0 auto',
        display: 'table',
        width: '100%',
        '& > div': {
          position: 'relative',
          display: 'table-cell',
          verticalAlign: 'middle',
          textAlign: 'right',
          width: '210px',
          '& > button': {
            maxWidth: '250px',
            width:'auto',
            height:'auto',
            minHeight:'40px',
            maxHeight:'50px',
            padding:'5px',
            minWidth:'177px',
            '& $textSpan':{
              font:"16px 'Roboto', sans-serif",
            },
            '& > span': {
              '&:lang(ar)': {
                display: 'block',
                direction: 'rtl'
              }
            }
          },
          '&:lang(ar)': {
            '@media (min-width:801px)': {
              textAlign: "left",
              paddingLeft: "0",
              paddingRight: "25px"
            }
          }
        },
        '& $firstColumn':{
          textAlign:'left',
          '&:lang(ar)': {
            textAlign: 'right!important',
          },
          '& $textSpan':{
            font:"500 13px 'Roboto', sans-serif",
          }
        }
      }
    },
    firstColumn:{},
    secondColumn:{},
    thirdColumn: {
      font:"300 13px 'Roboto', sans-serif",
      display: 'flex',
      justifyContent: 'flex-end',
      paddingTop: '5px',
    },
    textSpan:{},
    robotoBtn:{
      fontFamily:  'Roboto',
    },
  };
  